module.exports = __webpack_public_path__ + "img/ts19.3210c976.png";